import { ListExecution } from '@frontend/app/hooks';
import { GetMemberQuery_member } from '@frontend/app/queries/types/GetMemberQuery';
import { AUTOMATION_EXECUTION_ENDED_STATUSES } from '@frontend/app/components/AutomationAuditTable/AutomationAuditTableTypes';
import { format as formatDate } from 'date-fns';
import { AutomationExecution, AutomationExecutionStatusMap } from '../constants';

export const getMemberIdFromAutomationExecution = (execution: ListExecution) => {
  const member = execution?.variables?.find((variable) => variable.type === 'MEMBER');
  return parseInt(member?.value, 10);
};

export const listExecutionToAutomationExecutionAdapter = (
  execution: ListExecution,
  member?: GetMemberQuery_member,
): AutomationExecution => ({
  automation: execution?.automation,
  member,
  status: execution.status,
  dateTriggered: execution.createdDate,
  dateEnded: AUTOMATION_EXECUTION_ENDED_STATUSES.includes(execution.status) ? execution.updatedDate : null,
  id: execution.id,
});

export const useAutomationExecutionsTableAdapter = ({
  executions,
  members,
}: {
  executions: ListExecution[];
  members?: GetMemberQuery_member[];
}) =>
  executions.map((execution) => {
    const member = members?.find((member) => member.id === getMemberIdFromAutomationExecution(execution));
    return listExecutionToAutomationExecutionAdapter(execution, member);
  });

export const formatDateToReadableString = (date: string) => {
  if (!date) {
    return '';
  }
  return `${formatDate(new Date(date), 'MM/dd/yyyy')} at ${formatDate(new Date(date), 'hh:mm a')}`;
};

export const getAutomationExecutionStatus = (status: string) => {
  return AutomationExecutionStatusMap[status];
};
